import Cookies from 'js-cookie'

document.addEventListener('DOMContentLoaded', function () {
    // Cookie consent block

    var cookies = Cookies.get('deltabg_cookies')

    if (cookies != 1) {
        setTimeout(function () {
            document.querySelector('.cookie-consent').classList.add('show')
        }, 2000)

        document.getElementById('cookie-hide').addEventListener('click', function (e) {
            document.querySelector('.cookie-consent').classList.remove('show')
        })

        document.getElementById('cookie-agree').addEventListener('click', function (e) {
            Cookies.set('deltabg_cookies', 1, {
                expires: 365,
                path: '/'
            })

            document.querySelector('.cookie-consent').classList.remove('show')
        })
    }
})
